module.exports = __webpack_public_path__ + "static/media/REPLAY.bfaa7dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/REPLAY.png
// module id = 292
// module chunks = 0